module.exports = __webpack_public_path__ + "img/grain.ffa3b2a6.png";